import { Button, Modal } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';

import { validateTiers } from '@/utils';
import ListeTiers from './ListeTiers';

const ModalTiers = (props) => {
  const { civilites, selected, onValidate, onClose, ...rest } = props;

  // Etat de la liste des tierces personnes
  const [items, setItems] = React.useState(selected ? [selected] : []);
  // Etat de l'item sélectionné
  const [selectedItem, setSelectedItem] = React.useState(selected);
  // Erreurs dans la liste
  const [errors, setErrors] = React.useState([]);

  // Gestion de l'ajout d'un tiers
  const handleTiersAdd = React.useCallback(
    (item) => {
      const hasErrors = validateTiers(item);
      if (hasErrors.length > 0) {
        setErrors(hasErrors);

        return false;
      }

      setItems([item, ...items]);
      setSelectedItem(item);
      setErrors([]);

      return true;
    },
    [items],
  );

  // Gestion de la modification d'un tiers
  const handleTiersEdit = React.useCallback(
    (item) => {
      const hasErrors = validateTiers(item);
      if (hasErrors.length > 0) {
        setErrors(hasErrors);

        return false;
      }

      setItems(_.map(items, (i) => (i.identifiant === item?.identifiant ? item : i)));
      setSelectedItem(item);
      setErrors([]);

      return true;
    },
    [items],
  );

  // Gestion de la suppression d'un tiers
  const handleTiersDelete = React.useCallback(
    (item) => {
      setItems(_.filter(items, (i) => i.identifiant !== item.identifiant));
      setSelectedItem(null);

      return true;
    },
    [items],
  );

  // Gestion de la sélection d'un tiers
  const handleTiersSelect = React.useCallback((item, selectedItems) => {
    setSelectedItem(_.head(selectedItems));
  }, []);

  // Gestion de la validation
  const handleValidate = React.useCallback(() => {
    onValidate(selectedItem);
  }, [onValidate, selectedItem]);

  React.useEffect(() => {
    // remplacer ça par la récupération des tiers en bdd à terme
    if (selected) {
      setItems([selected]);
      setSelectedItem(selected);
    }
  }, [selected]);

  return (
    <Modal closeIcon open size="large" onClose={onClose} {...rest}>
      <Modal.Header>Règlement par un tiers</Modal.Header>
      <Modal.Content scrolling={false}>
        <div style={{ height: 370 }}>
          <ListeTiers
            items={items}
            errors={errors}
            civilites={civilites}
            selectedItems={selectedItem ? [selectedItem] : []}
            onItemAdd={handleTiersAdd}
            onItemEdit={handleTiersEdit}
            onItemDelete={handleTiersDelete}
            onItemSelect={handleTiersSelect}
          />
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button
          data-testid="modal-tiers-button-cancel"
          basic
          size="tiny"
          icon="close"
          content="Annuler"
          onClick={onClose}
        />
        <Button
          data-testid="modal-tiers-button-validate"
          icon="checkmark"
          content="Valider"
          onClick={handleValidate}
          positive={!_.isNil(selectedItem)}
          disabled={_.isNil(selectedItem)}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ModalTiers;
